import React, { ChangeEvent, useMemo, useState } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_FileUploadProps } from "./FileUpload.interface";
import S from "./FileUpload.module.scss";

export const DA_FileUpload = (props: DA_FileUploadProps) => {
    const { getDictionaryString } = useTranslations();

    const [fileName, setFileName] = useState<string>();

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;

        if (files && files.length > 0) {
            setFileName(files?.[0]?.name);

            if (typeof props.onChange !== "undefined") {
                props.onChange(files?.[0]?.name);
            }
        }
    };

    const uniqueId = useMemo(
        () => `file-upload-${Date.now()}-${Math.floor(Math.random() * (999 - 100 + 1) + 100)}`,
        []
    );

    return (
        <div className={cn(S.wrapper, props.className)}>
            {/* Input */}
            <input
                type="file"
                name={props.name}
                id={uniqueId}
                className={S.input}
                onChange={handleFileChange}
            />

            {/* Button */}
            <label htmlFor={uniqueId} className={S.button} data-name="button">
                {props.label || getDictionaryString("FileUpload.Button")}
            </label>

            {/* Name */}
            <span className={S.fileName} data-name="name">
                {fileName}
            </span>
        </div>
    );
};
